import { useFacebookClient } from './facebook_auth';
import { useMemo }           from 'react';
import Alert                 from '../../components/alert';
import FacebookAuth          from './facebook_auth';
import Link                  from '../../components/link';
import React                 from 'react';
import useDialog             from '../../hooks/use_dialog';

export default function CurrentPage({ facebookPage, facebookStatus, disconnect }) {
  const requiresAction = facebookStatus !== 200;

  return (
    <FacebookAuth>
      <div className="facebook-page">
        <PageInfo {...{ facebookPage, requiresAction }}/>
        {requiresAction && <ActionRequiredText/>}
        {requiresAction && <ConnectLocationButton/>}
        <DisconnectLocationButton {...{ facebookPage, disconnect }}/>
      </div>
    </FacebookAuth>
  );
}


function PageInfo({ facebookPage, requiresAction }) {
  const title = requiresAction ? 'Update Needed' : 'Connected';

  return (
    <div className="list block inset">
      <h3>{title}</h3>
      <FacebookName {...{ facebookPage }}/>
      <FacebookLink {...{ facebookPage }}/>
    </div>
  );

}

function DisconnectLocationButton({ facebookPage, disconnect }) {

  const defaultName = 'your Facebook Page';
  const name        = facebookPage?.name || defaultName;

  const buttons = useMemo(() => ([
    {
      text:  'Keep',
      close: true
    },
    {
      text:    'Disconnect',
      close:   true,
      danger:  true,
      bold:    true,
      color:   'red',
      onClick: disconnect
    }
  ]), [ disconnect ]);

  const onClick = useDialog({
    title:   'Disconnect Facebook Page',
    content: `Are you sure you want to disconnect ${name}?`,
    buttons
  });

  return (
    <div className="list media-list block inset">
      <div onClick={onClick} className="button danger disconnect-button">Disconnect</div>
    </div>
  );
}

function ConnectLocationButton() {
  const FB = useFacebookClient();

  function onClickSignIn() {
    FB.login(() => {}, { scope: 'manage_pages' });
  }

  return (
    <div className="list media-list block inset">
      <div onClick={onClickSignIn} className="button button-fill">Connect</div>
    </div>
  );
}

function FacebookName({ facebookPage }) {
  const name = facebookPage?.name;
  if (!name)
    return null;

  return (
    <p>
      <strong>{name}</strong>
    </p>
  );
}

function ActionRequiredText() {
  return (
    <div className="block inset">
      <Alert>We are still able to request Facebook reviews, but are having trouble reporting on them. Reconnect your Facebook page to update reporting.</Alert>
    </div>
  );
}

function FacebookLink({ facebookPage }) {
  const link = facebookPage?.link;
  if (!link)
    return null;

  return (
    <p>
      <Link href={link} external>
        <i className="f7-icons">exit</i>
        View on Facebook
      </Link>
    </p>
  );
}
